import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"

export class SignatureOptionsVM extends CommonOptionVM {
  required?: boolean

  constructor(data: Partial<SignatureOptionsVM> = {}) {
    super(data)
    this.required = data.required ?? undefined
  }

  validateData() {
    const errors: any[] = []
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default SignatureOptionsVM